import React from "react";
import JSONInspector from "@/modules/racket_lab_admin/JSONInspector";
import { useRacketLabAdminT } from "@/i18n/racketLabAdminI18n";

/**
 * LegacyRunReportCard — Sub-sprint D-β-β.
 *
 * Read-only viewer for `legacy-memberships-run-report` response.
 */
export const LegacyRunReportCard = ({ data, dataTestId = "rl-ops-legacy-run-report-card" }) => {
  const t = useRacketLabAdminT();
  if (!data) return null;
  const c = data.counts || {};
  const failuresCount = (data.failures || []).length;
  return (
    <div data-testid={dataTestId} className="flex flex-col gap-3 rounded-md border border-slate-200 bg-white p-4">
      <header className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="text-sm font-medium text-slate-800">{t("ops.legacy.run_report_page.card_title")}</h2>
        <code className="text-[10px] text-slate-500">{t("ops.legacy.run_report_page.run_id_label")} {data.run_id}</code>
      </header>
      <div className="flex flex-wrap gap-2 text-[11px]" data-testid={`${dataTestId}-counts`}>
        <span className="rounded-full bg-emerald-100 px-2 py-0.5 text-emerald-800">applied: <code>{c.applied ?? 0}</code></span>
        <span className="rounded-full bg-rose-100 px-2 py-0.5 text-rose-800">failed: <code>{c.failed ?? 0}</code></span>
        <span className="rounded-full bg-slate-100 px-2 py-0.5">skipped: <code>{c.skipped ?? 0}</code></span>
        <span className="rounded-full bg-slate-100 px-2 py-0.5">BACKFILL: <code>{c.BACKFILL ?? 0}</code></span>
        <span className="rounded-full bg-slate-100 px-2 py-0.5">SOFT_REVOKE: <code>{c.SOFT_REVOKE ?? 0}</code></span>
        <span className="rounded-full bg-slate-100 px-2 py-0.5">EXCLUDE: <code>{c.EXCLUDE ?? 0}</code></span>
      </div>
      <div className="flex flex-wrap gap-2 text-[10px] text-slate-500">
        <span>{t("ops.legacy.run_report_page.started_at_label")} {data.started_at_utc}</span>
        <span>{t("ops.legacy.run_report_page.ended_at_label")} {data.ended_at_utc}</span>
        <span>{t("ops.legacy.run_report_page.items_total_label")} {data.items_total}</span>
      </div>
      {failuresCount > 0 && (
        <div data-testid={`${dataTestId}-failures`}>
          <p className="mb-1 text-[11px] font-medium text-rose-700">{t("ops.legacy.run_report_page.failures_header", { count: failuresCount })}</p>
          <div className="overflow-x-auto rounded-md border border-rose-200">
            <table className="w-full text-[11px]">
              <thead className="bg-rose-50 text-left text-rose-800">
                <tr>
                  <th className="px-2 py-1">{t("ops.legacy.run_report_page.columns.user_hash")}</th>
                  <th className="px-2 py-1">{t("ops.legacy.run_report_page.columns.error_code")}</th>
                </tr>
              </thead>
              <tbody>
                {data.failures.map((f, i) => (
                  <tr key={i} className="border-t border-rose-100">
                    <td className="px-2 py-1 font-mono">{f.user_hash}</td>
                    <td className="px-2 py-1 font-mono">{f.error_code}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <JSONInspector value={data} dataTestId={`${dataTestId}-json`} />
    </div>
  );
};

export default LegacyRunReportCard;
